import React from "react";

export default function WarningBox({ showGlassPhotoIncreaseWarning }) {
  return (
    <div className="ch-card ch-ba--1 ch-mh--auto  ch-mb--2 warning-message">
      <div className="ch-content ch-pa--1 ch-pb--0 ">
        <p className="ch-fs--2 ch-ml--2 ch-mt--1 ch-mb--1">
          {showGlassPhotoIncreaseWarning
            ? "Making these changes could affect your final valuation and more photos will be required"
            : "Making these changes might affect your final valuation"}
        </p>
      </div>
    </div>
  );
}
